import { render, staticRenderFns } from "./UserAddAccount.vue?vue&type=template&id=792d3dd4"
import script from "./UserAddAccount.vue?vue&type=script&lang=js"
export * from "./UserAddAccount.vue?vue&type=script&lang=js"
import style0 from "./UserAddAccount.vue?vue&type=style&index=0&id=792d3dd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports